import { NgModule } from "@angular/core";
import { UiInteractionService } from "@obg/ngx.core";

import { COMMON_UI_INTERACTION_TRACKING_MAP } from "./telemetry/ui-interaction-telemetry.const";

@NgModule()
export class CommonUiModule {
	constructor(uiInteractionService: UiInteractionService) {
		uiInteractionService.registerTrackingData(COMMON_UI_INTERACTION_TRACKING_MAP);
	}
}
